var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"string"},_vm._l((this.strLength),function(index){return _c('div',{key:index,staticClass:"string--group"},[_vm._t("default")],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }